// src/features/oio/errors/ErrorRenderer.tsx
import { useErrorStore } from "./errorStore"
import { ReportIssueClient } from "./ReportIssueClient"
import { WarningBanner } from "./components/WarningBanner"
import { ErrorToast } from "./components/ErrorToast"
import { FatalErrorBanner } from "./components/FatalErrorBanner"
import type { ActiveError } from "./types"

interface ErrorRendererProps {
  onRetry: () => void
}

export function ErrorRenderer({ onRetry }: ErrorRendererProps) {
  const { removeError, fatalError, warnings, transientErrors } = useErrorStore()

  const fatal: ActiveError | undefined = fatalError()
  const warningList = warnings()
  const transientList = transientErrors()

  return (
    <>
      {warningList.map((err) => (
        <WarningBanner
          key={err.code}
          message={err.userMessage}
          onDismiss={() => removeError(err.code)}
        />
      ))}

      {transientList.map((err) => (
        <ErrorToast
          key={err.code}
          message={err.userMessage}
          onRetry={err.retryable ? onRetry : undefined}
          onDismiss={() => removeError(err.code)}
        />
      ))}

      {fatal && (
        <FatalErrorBanner
          message={fatal.userMessage}
          retryable={fatal.retryable}
          onRetry={onRetry}
          onReport={() => ReportIssueClient.report(fatal)}
        />
      )}
    </>
  )
}
